<div class="listing-content-wrapper">
  <div class="sticky-container">
    <div class="navigation-wrapper">
      <div class="navigation-header" (click)="onToggleMenu()">
        <h4 [innerHtml]="listing?.getName()"></h4>
        <h5 *ngIf="listing?.sites?.length > 1">
          <ion-list class="ion-no-padding">
            <ion-item class="ion-no-padding" lines="none">
              <ion-label class="no-wrap" style="font-size: 1.1em">Editing Site:</ion-label>
              <ion-select (ionChange)="onSelectSite($event)" [value]="selectedSite">
                <ion-select-option *ngFor="let site of listing?.sites ?? []" [value]="site">
                  {{ getSiteName(site) }} ({{ site.id }})
                </ion-select-option>
              </ion-select>
            </ion-item>
          </ion-list>
        </h5>
        <p *ngIf="lastSaved" class="fine-print-trinidad" style="float: left">
          Last saved at {{ lastSavedTime | date: 'shortTime' }}
        </p>
        <ion-icon name="chevron-down" class="chevron-toggle" *ngIf="!showMenu"> </ion-icon>
        <ion-icon name="chevron-up" class="chevron-toggle" *ngIf="showMenu"> </ion-icon>
      </div>
      <div class="navigation-body" [className]="!showMenu ? 'hide-menu' : ''">
        <div class="divider-line"></div>
        <div
          (click)="selectNavigation('description')"
          [ngClass]="{ selected: section === 'description' }"
          class="status-block"
        >
          <div class="rift-soft-title">Name &amp; Description</div>
          <div *ngIf="!descriptionCompleted()" class="required-pill">
            <p class="paragraph">TO DO</p>
          </div>
          <curbnturf-checked *ngIf="descriptionCompleted()"></curbnturf-checked>
        </div>
        <div (click)="selectNavigation('sites')" [ngClass]="{ selected: section === 'sites' }" class="status-block">
          <div class="rift-soft-title">Sites</div>
          <div *ngIf="!sitesCompleted()" class="required-pill">
            <p class="paragraph">TO DO</p>
          </div>
          <curbnturf-checked *ngIf="sitesCompleted()"> </curbnturf-checked>
        </div>
        <div
          (click)="selectNavigation('overview')"
          [ngClass]="{ selected: section === 'overview' }"
          class="status-block"
        >
          <div class="rift-soft-title">Overview</div>
          <div *ngIf="!overviewCompleted()" class="required-pill">
            <p class="paragraph">TO DO</p>
          </div>
          <curbnturf-checked *ngIf="overviewCompleted()"> </curbnturf-checked>
        </div>
        <div
          (click)="selectNavigation('directions')"
          [ngClass]="{ selected: section === 'directions' }"
          class="status-block"
        >
          <div class="rift-soft-title">Directions</div>
          <div *ngIf="!directionsCompleted()" class="required-pill">
            <p class="paragraph">TO DO</p>
          </div>
          <curbnturf-checked *ngIf="directionsCompleted()"> </curbnturf-checked>
        </div>
        <div
          (click)="selectNavigation('policies')"
          [ngClass]="{ selected: section === 'policies' }"
          class="status-block"
        >
          <div class="rift-soft-title">Rules &amp; Policies</div>
          <div *ngIf="!bookingCompleted()" class="required-pill">
            <p class="paragraph">TO DO</p>
          </div>
          <curbnturf-checked *ngIf="bookingCompleted()"> </curbnturf-checked>
        </div>

        <div (click)="selectNavigation('payout')" [ngClass]="{ selected: section === 'payout' }" class="status-block">
          <div class="rift-soft-title">Pricing &amp; Payout</div>
          <div *ngIf="!priceCompleted()" class="required-pill">
            <p class="paragraph">TO DO</p>
          </div>
          <curbnturf-checked *ngIf="priceCompleted()"> </curbnturf-checked>
        </div>
        <div
          (click)="selectNavigation('blackout')"
          [ngClass]="{ selected: section === 'blackout' }"
          class="status-block"
        >
          <div class="rift-soft-title">Blackout Dates</div>
        </div>
      </div>
      <div *ngIf="errors?.length > 0" class="alert-danger">
        <div *ngFor="let error of errors" [innerHTML]="error"></div>
      </div>
    </div>
  </div>
  <div class="accordion-all">
    <div *ngIf="listing" class="w-form">
      <ng-container *ngIf="section === 'description'">
        <curbnturf-description [listing]="listing"> </curbnturf-description>
      </ng-container>

      <ng-container *ngIf="section === 'sites'">
        <curbnturf-edit-sites [listing]="listing" (siteChanged)="onSiteChanged($event)"> </curbnturf-edit-sites>
      </ng-container>

      <ng-container *ngIf="section === 'overview'">
        <curbnturf-overview [site]="selectedSite" [listing]="listing"> </curbnturf-overview>
      </ng-container>

      <ng-container *ngIf="section === 'directions'">
        <curbnturf-directions [site]="selectedSite" [listing]="listing"> </curbnturf-directions>
      </ng-container>

      <ng-container *ngIf="section === 'policies'">
        <curbnturf-policies [listing]="listing"> </curbnturf-policies>
      </ng-container>

      <ng-container *ngIf="section === 'blackout'">
        <curbnturf-blackout [listing]="listing"> </curbnturf-blackout>
      </ng-container>

      <ng-container *ngIf="section === 'payout'">
        <curbnturf-payout [site]="selectedSite" [listing]="listing" (saved)="saved($event)"> </curbnturf-payout>
      </ng-container>
    </div>
    <p *ngIf="lastSaved" class="fine-print-trinidad right-align">
      Last saved at {{ lastSaved.toJSDate() | date: 'shortTime' }}
    </p>
  </div>
</div>

<curbnturf-enable-confirmation-modal> </curbnturf-enable-confirmation-modal>

<div class="spinner-wrapper" *ngIf="spinnerOn">
  <curbnturf-spinner [show]="spinnerOn"> </curbnturf-spinner>
</div>
